import styles from './index.module.scss';
import MarkIcon from './images/mark.svg?react';
import DownUpIcon from './images/down.svg?react';
import type { AffixShortcutProps } from './type';
import { ShortcutType } from './type';

const AffixShortcut = ({
  newMessageCounts,
  markCounts,
  onClick,
}: AffixShortcutProps) => {
  return (
    <div className={styles.affixShortcut}>
      {!!markCounts && (
        <div className={styles.item} onClick={() => onClick(ShortcutType.MARK)}>
          <div className={styles.count}>{markCounts}</div>
          <MarkIcon />
        </div>
      )}
      {!!newMessageCounts && (
        <div className={styles.item} onClick={() => onClick(ShortcutType.DOWN_UP)}>
          <div className={styles.count}>{newMessageCounts}</div>
          <DownUpIcon />
        </div>
      )}
    </div>
  );
};
export default AffixShortcut;
